import { render, staticRenderFns } from "./DecastCardShimmer.vue?vue&type=template&id=e2dc06f6&scoped=true&"
import script from "./DecastCardShimmer.vue?vue&type=script&lang=js&"
export * from "./DecastCardShimmer.vue?vue&type=script&lang=js&"
import style0 from "./DecastCardShimmer.vue?vue&type=style&index=0&id=e2dc06f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2dc06f6",
  null
  
)

export default component.exports